import { useQuery } from "@tanstack/react-query";
import { Method, callEndpoint } from "../../../../http/axiosConfig";
import { OnDemandActionType, OnDemandThresholdUnit } from "@util/constants.ts";

export interface OnDemandAction {
  id: number;
  action_type: OnDemandActionType;
  on_demand_threshold: number;
  threshold_unit: OnDemandThresholdUnit;
}

export const ON_DEMAND_ACTIONS_QUERY_KEY = ["on-demand-actions"];

export default function useOnDemandActions() {
  return useQuery<OnDemandAction[], Error>({
    queryKey: ON_DEMAND_ACTIONS_QUERY_KEY,
    queryFn: () => {
      return callEndpoint(Method.GET, "/api/on-demand-actions");
    },
  });
}
